// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tours-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.tours-h1 {
  text-align: center;
  color: #004d00;
  font-size: 1.2rem;
  margin: 1rem 0 2rem 0;
  text-transform: capitalize;
}

.tour-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
  justify-content: flex-start;
  align-items: flex-start;
}

.filter-section {
  width: 280px;
  margin-right: 2rem;
  padding: 0.5rem 1.5rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.3rem;
}

.filter-group div {
  display: flex;
}

.filter-group .number-box {
  margin: 0 0.5rem;
  border: solid 1px #ddd;
  border-radius: 0.5rem;
  width: 5rem;
}

.filter-group input {
  margin-right: 0.3rem;
}
.filter-group h4 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}
.filter-group label {
  font-size: 0.9rem;
  margin: 0 0 0 0.5rem;
  font-weight: 500;
}
.filter-group hr {
  border: 1px solid #ddd;
  margin-top: 0.5em;
}

.tour-list {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.tour-card {
  display: flex;
  margin-bottom: 2rem;
  border: 1px solid #eee;
  border-radius: 0.5rem;
  padding: 1.5rem;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background: white;
  cursor: pointer;
}

.tour-image-container {
  position: relative;
}

.tour-image {
  width: 300px;
  height: 200px;
  object-fit: cover;
  border-radius: 0.5rem;
  margin-right: 2rem;
}

.tour-destination {
  background-color: #004d00a4;
  font-size: 0.9rem;
  padding: 0.3rem 0.5rem;
  color: white;
  position: absolute;
  top: 0.3rem;
  left: 0.3em;
  border-radius: 5px;
  font-weight: 500;
  z-index: 1;
}

.tour-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0;
}

.tour-info {
  flex: 2 1;
  padding-right: 2rem;
}

.tour-location {
  font-size: 0.8rem;
  color: #004d00;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.tour-title {
  font-size: 1.2rem;
  margin: 0;
  color: #004d00;
  text-transform: uppercase;
  font-weight: 600;
}

.tour-summary {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
  font-size: 0.9rem;
  line-height: 1.8;
}

.tour-special {
  font-size: 0.8em;
  color: #004d00;
  display: flex;
  gap: 2rem; /* 간격 조정 */
}

.special-item + .special-item {
  margin-left: 1rem;
}

.tour-details-card {
  min-width: 180px;
  padding-left: 2rem;
  border-left: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.tour-days {
  font-size: 0.9rem;
  color: #000;
}

.tour-price {
  font-size: 1.5rem;
  font-weight: 600;
  color: #004d00;
  margin: 0.5rem 0;
}

.about-btn {
  background-color: #fff;
  color: #004d00;
  border: 1px solid #004d00;
  padding: 0.8rem 2rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
}

.about-btn:hover {
  background-color: #004d00;
  color: #fff;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.pagination button {
  margin: 0 0.2rem;
  padding: 0.5rem 1rem;
  border: none;
  background-color: #f0f0f0;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
}

.pagination button.active {
  background-color: #e8c140;
  color: white;
  font-weight: 700;
}

.pagination button:hover {
  background-color: #ddd;
  color: #e8c140;
}

.check-icon {
  color: #4caf50;
  font-size: 1rem;
  vertical-align: middle;
  margin-left: 5px;
}

.times-icon {
  color: #f44336;
  font-size: 1rem;
  vertical-align: middle;
  margin-left: 5px;
}

.special-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
.tour-details-card-left {
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 1rem;
}
@media (min-width: 800px) and (max-width: 1024px) {
  .filter-section {
    display: none;
  }
  .tour-image {
    width: 250px;
    height: 150px;
  }
  .tour-destination {
    font-size: 0.8rem;
  }
  .tour-title {
    font-size: 1.2rem;
  }
  .tour-summary {
    font-size: 1rem;
  }
}

/* 모바일: max-width 768px */
@media (max-width: 768px) {
  .tour-container {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .filter-section {
    display: none;
  }
  .filter-section h2 {
    display: block;
  }
  .tourlist {
    flex: 1 1;
  }
  .tour-image {
    width: 200px;
    height: 150px;
  }
  .tour-content {
    flex-direction: column;
  }
  .tour-details-card {
    border-left: none;
    border-top: 1px solid #eee;
    padding-top: 1rem;
    margin-top: 1rem;
    padding-left: 0;
  }

  .pagination {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
@media (max-width: 480px) {
  .tour-card {
    flex-direction: column;
    padding: 1rem;
  }
  .tour-image {
    width: 100%;
    height: 200px;
    margin-bottom: 1rem;
    margin-right: 0;
  }
  .tour-info {
    width: 100%;
    padding-bottom: 1rem;
  }
  .tour-price {
    font-size: 1.3rem;
  }
  .tour-details-card {
    width: 100%;
    height: 100%;
    border-left: none;
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: space-between;
  }
  .tours-h1 {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .tours-section {
    padding: 10px;
  }

  .check-icon,
  .times-icon {
    font-size: 0.9rem;
  }
}

.toggle-view {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
  gap: 0.5rem;
  width: 100%;
}
.toggle-view-btn {
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toggle-view-btn svg {
  color: #004d00;
  font-size: 1.2rem;
}
.toggle-view-btn.active {
  background-color: #004d00;
  color: #fff;
}
.toggle-view-btn.active svg {
  color: #fff;
}

.tour-list.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 1rem;
}
.tour-list.grid .tour-card {
  display: flex;
  flex-direction: column;
  margin-bottom: 0rem;
  border: 1px solid #eee;
  border-radius: 0.5rem;
  padding: 10px;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background: white;
}
.tour-list.grid .tour-card .tour-image {
  width: 100%;
  height: 150px;
}
.tour-list.grid .tour-card .tour-content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem 0;
}
.tour-list.grid .tour-card .tour-title {
  font-size: 1rem;
  margin: 0;
  color: #004d00;
  text-transform: uppercase;
  font-weight: 600;
}
.tour-list.grid .tour-card .tour-info {
  width: 100%;
  padding: 0;
}
.tour-list .tour-card .tour-info .tour-price {
  display: none;
}
.tour-list.grid .tour-card .tour-info .tour-price {
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
}
.tour-list.grid .tour-card .tour-info .tour-price button {
  background-color: white;
  color: #004d00;
  border: 1px solid #004d00;
  border-radius: 5px;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}
.tour-list.grid .tour-card .tour-info .tour-price button:hover {
  background-color: #004d00;
  color: #fff;
}
.tour-list.grid .tour-card .tour-special {
  display: none;
}

.tour-list.grid .tour-card .tour-details-card {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/tours.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAO;EACT;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".tours-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0;\n}\n\n.tours-h1 {\n  text-align: center;\n  color: #004d00;\n  font-size: 1.2rem;\n  margin: 1rem 0 2rem 0;\n  text-transform: capitalize;\n}\n\n.tour-container {\n  display: flex;\n  width: 100%;\n  max-width: 1200px;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.filter-section {\n  width: 280px;\n  margin-right: 2rem;\n  padding: 0.5rem 1.5rem;\n  background: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.filter-group {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 0.3rem;\n}\n\n.filter-group div {\n  display: flex;\n}\n\n.filter-group .number-box {\n  margin: 0 0.5rem;\n  border: solid 1px #ddd;\n  border-radius: 0.5rem;\n  width: 5rem;\n}\n\n.filter-group input {\n  margin-right: 0.3rem;\n}\n.filter-group h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n}\n.filter-group label {\n  font-size: 0.9rem;\n  margin: 0 0 0 0.5rem;\n  font-weight: 500;\n}\n.filter-group hr {\n  border: 1px solid #ddd;\n  margin-top: 0.5em;\n}\n\n.tour-list {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.tour-card {\n  display: flex;\n  margin-bottom: 2rem;\n  border: 1px solid #eee;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  width: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  background: white;\n  cursor: pointer;\n}\n\n.tour-image-container {\n  position: relative;\n}\n\n.tour-image {\n  width: 300px;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 0.5rem;\n  margin-right: 2rem;\n}\n\n.tour-destination {\n  background-color: #004d00a4;\n  font-size: 0.9rem;\n  padding: 0.3rem 0.5rem;\n  color: white;\n  position: absolute;\n  top: 0.3rem;\n  left: 0.3em;\n  border-radius: 5px;\n  font-weight: 500;\n  z-index: 1;\n}\n\n.tour-content {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.5rem 0;\n}\n\n.tour-info {\n  flex: 2;\n  padding-right: 2rem;\n}\n\n.tour-location {\n  font-size: 0.8rem;\n  color: #004d00;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n.tour-title {\n  font-size: 1.2rem;\n  margin: 0;\n  color: #004d00;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.tour-summary {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 10px;\n  font-size: 0.9rem;\n  line-height: 1.8;\n}\n\n.tour-special {\n  font-size: 0.8em;\n  color: #004d00;\n  display: flex;\n  gap: 2rem; /* 간격 조정 */\n}\n\n.special-item + .special-item {\n  margin-left: 1rem;\n}\n\n.tour-details-card {\n  min-width: 180px;\n  padding-left: 2rem;\n  border-left: 1px solid #eee;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.tour-days {\n  font-size: 0.9rem;\n  color: #000;\n}\n\n.tour-price {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #004d00;\n  margin: 0.5rem 0;\n}\n\n.about-btn {\n  background-color: #fff;\n  color: #004d00;\n  border: 1px solid #004d00;\n  padding: 0.8rem 2rem;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.about-btn:hover {\n  background-color: #004d00;\n  color: #fff;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.pagination button {\n  margin: 0 0.2rem;\n  padding: 0.5rem 1rem;\n  border: none;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  width: 2.5rem;\n  height: 2.5rem;\n  cursor: pointer;\n}\n\n.pagination button.active {\n  background-color: #e8c140;\n  color: white;\n  font-weight: 700;\n}\n\n.pagination button:hover {\n  background-color: #ddd;\n  color: #e8c140;\n}\n\n.check-icon {\n  color: #4caf50;\n  font-size: 1rem;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.times-icon {\n  color: #f44336;\n  font-size: 1rem;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.special-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.tour-details-card-left {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  gap: 1rem;\n}\n@media (min-width: 800px) and (max-width: 1024px) {\n  .filter-section {\n    display: none;\n  }\n  .tour-image {\n    width: 250px;\n    height: 150px;\n  }\n  .tour-destination {\n    font-size: 0.8rem;\n  }\n  .tour-title {\n    font-size: 1.2rem;\n  }\n  .tour-summary {\n    font-size: 1rem;\n  }\n}\n\n/* 모바일: max-width 768px */\n@media (max-width: 768px) {\n  .tour-container {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .filter-section {\n    display: none;\n  }\n  .filter-section h2 {\n    display: block;\n  }\n  .tourlist {\n    flex: 1;\n  }\n  .tour-image {\n    width: 200px;\n    height: 150px;\n  }\n  .tour-content {\n    flex-direction: column;\n  }\n  .tour-details-card {\n    border-left: none;\n    border-top: 1px solid #eee;\n    padding-top: 1rem;\n    margin-top: 1rem;\n    padding-left: 0;\n  }\n\n  .pagination {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n}\n@media (max-width: 480px) {\n  .tour-card {\n    flex-direction: column;\n    padding: 1rem;\n  }\n  .tour-image {\n    width: 100%;\n    height: 200px;\n    margin-bottom: 1rem;\n    margin-right: 0;\n  }\n  .tour-info {\n    width: 100%;\n    padding-bottom: 1rem;\n  }\n  .tour-price {\n    font-size: 1.3rem;\n  }\n  .tour-details-card {\n    width: 100%;\n    height: 100%;\n    border-left: none;\n    margin-top: 1rem;\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    justify-content: space-between;\n  }\n  .tours-h1 {\n    font-size: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .tours-section {\n    padding: 10px;\n  }\n\n  .check-icon,\n  .times-icon {\n    font-size: 0.9rem;\n  }\n}\n\n.toggle-view {\n  width: 100%;\n  max-width: 1200px;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n  gap: 0.5rem;\n  width: 100%;\n}\n.toggle-view-btn {\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.toggle-view-btn svg {\n  color: #004d00;\n  font-size: 1.2rem;\n}\n.toggle-view-btn.active {\n  background-color: #004d00;\n  color: #fff;\n}\n.toggle-view-btn.active svg {\n  color: #fff;\n}\n\n.tour-list.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));\n  gap: 1rem;\n}\n.tour-list.grid .tour-card {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0rem;\n  border: 1px solid #eee;\n  border-radius: 0.5rem;\n  padding: 10px;\n  width: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  background: white;\n}\n.tour-list.grid .tour-card .tour-image {\n  width: 100%;\n  height: 150px;\n}\n.tour-list.grid .tour-card .tour-content {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  width: 100%;\n  padding: 0.5rem 0;\n}\n.tour-list.grid .tour-card .tour-title {\n  font-size: 1rem;\n  margin: 0;\n  color: #004d00;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.tour-list.grid .tour-card .tour-info {\n  width: 100%;\n  padding: 0;\n}\n.tour-list .tour-card .tour-info .tour-price {\n  display: none;\n}\n.tour-list.grid .tour-card .tour-info .tour-price {\n  font-size: 1.3rem;\n  display: flex;\n  justify-content: space-between;\n}\n.tour-list.grid .tour-card .tour-info .tour-price button {\n  background-color: white;\n  color: #004d00;\n  border: 1px solid #004d00;\n  border-radius: 5px;\n  padding: 0.5rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n}\n.tour-list.grid .tour-card .tour-info .tour-price button:hover {\n  background-color: #004d00;\n  color: #fff;\n}\n.tour-list.grid .tour-card .tour-special {\n  display: none;\n}\n\n.tour-list.grid .tour-card .tour-details-card {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
